import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    duplicate: translate({ id: 'orders.configuration.duplicate' }),
    goToPaired: (type: uui.domain.client.rm.OrderStepIdentifier): string => {
      const id = type === 'd' ? 'orders.goTo.pickup' : 'orders.goTo.dropoff'

      return translate({ id })
    },
    pairedOutOfRangeTooltipTitle: (
      type: uui.domain.client.rm.OrderStepIdentifier,
      orderName: string,
    ): string => {
      const id =
        type === 'd'
          ? 'orders.goTo.pairedOutOfRange.pickup.title'
          : 'orders.goTo.pairedOutOfRange.dropoff.title'

      return translate({ id, values: { orderName } })
    },
    pairedOutOfRangeTooltipSubtitle: (
      type: uui.domain.client.rm.OrderStepIdentifier,
      vehicleName: string,
      date: string,
    ): string => {
      const id =
        type === 'd'
          ? 'orders.goTo.pairedOutOfRange.pickup.subtitle'
          : 'orders.goTo.pairedOutOfRange.dropoff.subtitle'

      return translate({
        id,
        values: { vehicleName, date },
      })
    },
    duplicateDisabledTooltipTitle: (isSimulation: boolean) => {
      const id = isSimulation
        ? 'orders.duplicate.disabled.simulations.title'
        : 'orders.duplicate.disabled.operations.title'
      return translate({ id })
    },

    duplicateDisabledTooltipSubtitle: (isSimulation: boolean, count: number) => {
      const id = isSimulation
        ? 'orders.duplicate.disabled.simulations.subtitle'
        : 'orders.duplicate.disabled.operations.subtitle'
      return translate({ id, values: { count } })
    },
    copyToOperations: translate({ id: 'global.copyToOperations' }),
    exportOrder: translate({ id: 'orders.configuration.export' }),
    exportExecution: translate({ id: 'orders.execution.export' }),
    fitInOrder: translate({ id: 'rm.contextual.order.fitIn' }),
    unassignOrder: translate({ id: 'global.unassign' }),
    canUnassignTooltipTitle: translate({
      id: 'orders.action.unassign.tooltip.disabledForLockedRoute',
      values: { count: 1 },
    }),
    deleteOrder: translate({ id: 'global.delete' }),
    editOrder: translate({ id: 'global.edit' }),
    editOrderDisabledInCommunication: translate({ id: 'orders.editDisabledInCommunication' }),
    more: translate({ id: 'global.more' }),

    editBtnTitle: (vehicleTracked: boolean) =>
      vehicleTracked
        ? ''
        : translate({ id: 'orders.executionEvents.action.edit.noVehicleTracked' }),
  }))

  return api
}
